import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'TradeRule',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TradeRule',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TradeRule',
    column_type: 'datetime',
  },
  hint: {
    model_name: 'TradeRule',
    column_type: 'string',
  },
  name: {
    model_name: 'TradeRule',
    column_type: 'string',
  },
  content: {
    model_name: 'TradeRule',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
